(function (factory) {
  if (typeof jQuery === 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof jQuery === 'undefined') {
        console.error('jQuery is required but not loaded');
        return;
      }
      factory(jQuery);
    });
  } else {
    factory(jQuery);
  }
})(function ($) {
  // 初始化弹窗
  function initVariantPopup() {
    // 添加滚动锁定容器
    if ($('.scroll-lock-container').length === 0) {
      $('body').append('<div class="scroll-lock-container"></div>');
    }
    
    // 添加关闭事件
    $('.variant-popup-close').on('click', closeVariantPopup);
    $('.variant-popup-overlay').on('click', function (e) {
      if (e.target === this) {
        closeVariantPopup();
      }
    });
    
    // 添加ESC键关闭
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        closeVariantPopup();
      }
    });
  }

  // 锁定滚动
  function lockScroll() {
    // 保存当前滚动位置
    const scrollY = window.scrollY;
    
    // 计算滚动条宽度
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    
    // 添加锁定类
    $('html, body').addClass('popup-open');
    
    // 激活滚动锁定容器
    $('.scroll-lock-container').addClass('active');
    
    // 设置滚动位置
    $('.scroll-lock-container').css('top', -scrollY + 'px');
    
    // 保存滚动位置
    $('body').attr('data-scroll-position', scrollY);
  }

  // 解锁滚动
  function unlockScroll() {
    // 移除锁定类
    $('html, body').removeClass('popup-open');
    
    // 停用滚动锁定容器
    $('.scroll-lock-container').removeClass('active');
    
    // 恢复滚动位置
    const scrollY = parseInt($('body').attr('data-scroll-position') || '0');
    window.scrollTo(0, scrollY);
  }

  // 打开弹窗
  function openVariantPopup(productData) {
    const $overlay = $('.variant-popup-overlay');
    const $popup = $('.variant-popup');
    const $content = $('.variant-popup-content');
    
    // 显示加载状态
    $content.html('<div style="text-align:center;padding:40px;"><div class="loading-spinner"></div></div>');
    
    // 锁定滚动
    lockScroll();
    
    // 显示弹窗
    $overlay.addClass('active');
    $popup.addClass('active');
    
    // 获取产品数据 - 使用产品URL
    const productUrl = productData.productUrl;
    const productHandle = productUrl ? productUrl.split('/').pop().split('?')[0] : '';
    
    if (!productUrl || !productHandle) {
      $content.html('<div style="text-align:center;padding:20px;"><p>Product URL does not exist</p></div>');
      return;
    }
    
    // 首先尝试使用模板视图
    $.ajax({
      url: '/products/' + productHandle + '?view=variant-popup',
      type: 'GET',
      success: function(response) {
        if (response.trim() === '') {
          // 如果响应为空，回退到API方法
          fetchProductDataAndRender(productHandle, $content);
        } else {
          $content.html(response);
          // 初始化弹窗内的交互
          initVariantPopupInteractions(productData);
        }
      },
      error: function() {
        // 如果请求失败，回退到API方法
        fetchProductDataAndRender(productHandle, $content);
      }
    });
  }
  
  // 使用API获取产品数据并渲染
  function fetchProductDataAndRender(productHandle, $content) {
    $.ajax({
      url: '/products/' + productHandle + '.js',
      type: 'GET',
      dataType: 'json',
      success: function(product) {
        // 存储产品数据以供后续使用
        window.productData = product;
        
        // 渲染产品数据
        // renderProductPopup(product, $content);
        
        // 初始化弹窗内的交互
        initVariantPopupInteractions(product);
      },
      error: function() {
        $content.html('<div style="text-align:center;padding:20px;"><p>Error loading product information</p></div>');
      }
    });
  }

  // // 渲染产品弹窗
  // function renderProductPopup(product, $content) {
  //   // 获取产品图片
  //   let productImage = '';
  //   if (product.featured_image) {
  //     productImage = product.featured_image;
  //   } else if (product.images && product.images.length > 0) {
  //     productImage = product.images[0];
  //   }
    
  //   // 构建变体选项HTML
  //   let optionsHtml = '';
  //   if (product.options && product.options.length > 1) {
  //     optionsHtml = '<div class="variant-popup-options">';
  //     product.options.forEach((option, optionIndex) => {
  //       optionsHtml += `
  //         <div class="variant-popup-option" data-option-index="${optionIndex}">
  //           <span class="option-name">${option}</span>
  //           <div class="option-values">
  //       `;
        
  //       // 获取此选项的所有唯一值
  //       const values = [];
  //       product.variants.forEach(variant => {
  //         const value = variant.options[optionIndex];
  //         if (!values.includes(value)) {
  //           values.push(value);
  //         }
  //       });
        
  //       // 为每个值创建单选按钮
  //       values.forEach(value => {
  //         optionsHtml += `
  //           <div class="option-value">
  //             <input
  //               type="radio"
  //               id="popup-option${optionIndex}-${value.replace(/\s+/g, '-').toLowerCase()}"
  //               name="option${optionIndex}"
  //               value="${value}"
  //               data-option-index="${optionIndex}"
  //               ${optionIndex === 0 ? 'checked' : ''}>
  //             <label for="popup-option${optionIndex}-${value.replace(/\s+/g, '-').toLowerCase()}">
  //               <span class="option-value__text">${value}</span>
  //             </label>
  //           </div>
  //         `;
  //       });
        
  //       optionsHtml += `
  //           </div>
  //         </div>
  //       `;
  //     });
  //     optionsHtml += '</div>';
  //   }
    
  //   // 构建完整的HTML
  //   const html = `
  //     <div class="variant-popup-product">
  //       <div class="variant-popup-row">
  //         <!-- 左侧模块 - 产品图片 -->
  //         <div class="variant-popup-left">
  //           <div class="variant-popup-product-media">
  //             ${productImage ? `<img src="${productImage}" alt="${product.title}" class="img-fluid" loading="lazy">` : '<div class="no-image">No Image</div>'}
  //           </div>
  //         </div>
          
  //         <!-- 右侧模块 - 产品信息和功能 -->
  //         <div class="variant-popup-right">
  //           <!-- 标题和转发按钮 -->
  //           <div class="variant-popup-header">
  //             <h2 class="variant-popup-product-title">${product.title}</h2>
  //             <div class="variant-popup-share">
  //               <div class="a2a_kit a2a_kit_size_24 a2a_default_style a2a_flex_style">
  //                 <a
  //                   class="a2a_dd icon-link"
  //                   href="https://www.addtoany.com/share"
  //                   rel="nofollow">
  //                   <svg
  //                     xmlns="http://www.w3.org/2000/svg"
  //                     width="21"
  //                     height="21"
  //                     fill="currentColor"
  //                     viewBox="0 0 28 28">
  //                     <path fill-rule="evenodd" d="M22.1667 22.1667H5.83333V5.83333H14V3.5H5.83333C4.53833 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.53833 24.5 5.83333 24.5H22.1667C23.45 24.5 24.5 23.45 24.5 22.1667V14H22.1667V22.1667ZM16.3333 3.5V5.83333H20.5217L9.05333 17.3017L10.6983 18.9467L22.1667 7.47833V11.6667H24.5V3.5H16.3333Z" />
  //                   </svg>
  //                 </a>
  //               </div>
  //             </div>
  //           </div>
            
  //           <!-- 变体选择器 -->
  //           <form id="variant-popup-form" class="variant-popup-form">
  //             ${optionsHtml}
              
  //             <!-- 数量选择器 -->
  //             <div class="variant-popup-quantity">
  //               <span class="quantity-selector__label">Quantity</span>
  //               <div class="quantity-selector__controls">
  //                 <button 
  //                   type="button" 
  //                   class="quantity-selector__button quantity-selector__button--minus" 
  //                   aria-label="Decrease quantity"
  //                   disabled>
  //                   -
  //                 </button>
  //                 <input
  //                   type="number"
  //                   name="quantity"
  //                   class="quantity-selector__input"
  //                   value="1"
  //                   min="1"
  //                   max="9999"
  //                   aria-label="Quantity">
  //                 <button 
  //                   type="button" 
  //                   class="quantity-selector__button quantity-selector__button--plus"
  //                   aria-label="Increase quantity">
  //                   +
  //                 </button>
  //               </div>
  //             </div>
              
  //             <!-- 价格显示 -->
  //             <div class="variant-popup-price">
  //               <span class="product-price__regular">${formatMoney(product.price)}</span>
  //               ${product.compare_at_price > product.price ? 
  //                 `<span class="product-price__compare">${formatMoney(product.compare_at_price)}</span>
  //                 <span class="product-price__discount">-${formatMoney(product.compare_at_price - product.price)}</span>` : ''}
  //             </div>
              
  //             <!-- 添加到购物车按钮 -->
  //             <div class="variant-popup-buttons">
  //               <input type="hidden" name="id" value="${product.variants[0].id}">
  //               <button
  //                 type="submit"
  //                 name="add"
  //                 class="variant-popup-add-to-cart"
  //                 ${!product.available ? 'disabled' : ''}>
  //                 ${product.available ? '+ ADD TO CART' : 'SOLD OUT'}
  //               </button>
  //             </div>
              
  //             <!-- 支付方式图标 -->
  //             <div class="variant-popup-payment-icons">
  //               <img src="https://cdn.shopify.com/shopifycloud/shopify/assets/payment_icons/visa-319d545c6fd255c9aad5eeaad21fd6f7f7b4fdbdb1a35ce83b89cca12a187f00.svg" class="payment-icon" alt="Visa">
  //               <img src="https://cdn.shopify.com/shopifycloud/shopify/assets/payment_icons/master-173035bc8124581983d4efa50cf8626e8553c2b311353fbf67485f9c1a2b88d1.svg" class="payment-icon" alt="Mastercard">
  //               <img src="https://cdn.shopify.com/shopifycloud/shopify/assets/payment_icons/american_express-2264c9b8b57b23b0b0831827e90cd7bcda2836adc42a912ebedf545dead35b20.svg" class="payment-icon" alt="American Express">
  //               <img src="https://cdn.shopify.com/shopifycloud/shopify/assets/payment_icons/apple_pay-f6db0077dc7c325b436ecbdcf254239100b35b70b1663bc7523d7c424901fa09.svg" class="payment-icon" alt="Apple Pay">
  //               <img src="https://cdn.shopify.com/shopifycloud/shopify/assets/payment_icons/shopify_pay-100fde795157a3d1c18042346cf8dbd1c84b3f59df5b648f95d40785000d5665.svg" class="payment-icon" alt="Shop Pay">
  //             </div>
  //           </form>
  //         </div>
  //       </div>
  //     </div>
      
  //     <script>
  //       // 存储产品数据以供JavaScript使用
  //       window.productData = ${JSON.stringify(product)};
  //     </script>
  //   `;
    
  //   $content.html(html);
  // }

  // 格式化金额
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = parseInt(cents);
    }
    const value = (cents / 100).toFixed(2);
    return '$' + value;
  }
  
  // 关闭弹窗
  function closeVariantPopup() {
    const $overlay = $('.variant-popup-overlay');
    const $popup = $('.variant-popup');
    
    $overlay.removeClass('active');
    $popup.removeClass('active');
    
    // 解锁滚动
    unlockScroll();
    
    // 清空弹窗内容，防止关闭后仍能点击
    setTimeout(function() {
      if (!$popup.hasClass('active')) {
        $('.variant-popup-content').empty();
      }
    }, 300); // 等待过渡动画完成
  }
  
  // 初始化View More按钮点击事件
  function initViewMoreButtons() {
    $(document).on('click', '.view-more-btn', function (e) {
      e.preventDefault();
      
      const $button = $(this);
      const productId = $button.attr('data-product-id');
      const productUrl = $button.attr('data-product-url');
      
      // 打开弹窗
      openVariantPopup({
        productId: productId,
        productUrl: productUrl
      });
    });
  }
  
  // 在DOM加载完成后初始化
  $(function () {
    console.log('Variant popup initialized');
    initVariantPopup();
    initViewMoreButtons();
  });
  
  // 暴露公共方法
  window.VariantPopup = {
    open: openVariantPopup,
    close: closeVariantPopup,
  };

  // 初始化AddToAny分享按钮
  function initAddToAny() {
    if (window.a2a) {
      a2a.init_all();
    } else {
      // 如果AddToAny脚本尚未加载，添加脚本
      const script = document.createElement('script');
      script.src = 'https://static.addtoany.com/menu/page.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }

  // 在弹窗内容加载完成后初始化Swiper和其他交互
  function initVariantPopupInteractions(productData) {
    // 先移除所有事件处理程序，防止重复绑定
    $('.variant-popup-option input[type="radio"]').off('change');
    $('.quantity-selector__button').off('click');
    $('.quantity-selector__input').off('change');
    $('.variant-popup-form').off('submit');
    
    // 直接从页面脚本标签获取产品数据
    try {
      const productDataFromScript = JSON.parse($('#product-data-script').text());
      window.productData = productDataFromScript;
    } catch (e) {
      // 如果从脚本标签加载失败，尝试使用传入的参数
      if (productData) {
        window.productData = productData;
      }
    }
    
    // 初始化PC端Swiper轮播
    if (window.innerWidth >= 1366) {
      // 确保Swiper已定义
      if (typeof Swiper !== 'undefined') {
        try {
          // 先销毁可能存在的旧实例
          if (window.popupThumbsSwiper) {
            window.popupThumbsSwiper.destroy(true, true);
          }
          if (window.popupMainSwiper) {
            window.popupMainSwiper.destroy(true, true);
          }
          
          // 初始化缩略图轮播
          window.popupThumbsSwiper = new Swiper(".popup-mySwiper", {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
          });
          
          // 初始化主轮播
          window.popupMainSwiper = new Swiper(".popup-mySwiper2", {
            loop: false,
            pagination: {
              el: '.popup-mySwiper-pagination',
              clickable: true,
            },
            spaceBetween: 10,
            thumbs: {
              swiper: window.popupThumbsSwiper,
            },
          });
        } catch (e) {
          // 忽略错误
        }
      }
    }
    
    // 变体选择
    $('.variant-popup-option input[type="radio"]').on('change', function() {
      // 确保productData存在
      if (!window.productData) {
        return;
      }
      updateSelectedVariant();
    });
    
    // 数量减少按钮
    $('.quantity-selector__button--minus').on('click', function() {
      const $input = $(this).siblings('.quantity-selector__input');
      let value = parseInt($input.val());
      if (value > 1) {
        value--;
        $input.val(value);
        $input.trigger('change');
      }
    });
    
    // 数量增加按钮
    $('.quantity-selector__button--plus').on('click', function() {
      const $input = $(this).siblings('.quantity-selector__input');
      let value = parseInt($input.val());
      value++;
      $input.val(value);
      $input.trigger('change');
    });
    
    // 数量输入框变化
    $('.quantity-selector__input').on('change', function() {
      let value = parseInt($(this).val());
      if (isNaN(value) || value < 1) {
        value = 1;
        $(this).val(1);
      }
      
      // 同步PC端和移动端的数量
      $('.quantity-selector__input').val(value);
      
      // 更新减号按钮状态
      $('.quantity-selector__button--minus').prop('disabled', value <= 1);
      
      // 确保productData存在
      if (!window.productData) {
        // 尝试重新加载产品数据
        try {
          const productDataFromScript = JSON.parse($('#product-data-script').text());
          window.productData = productDataFromScript;
        } catch (e) {
          return;
        }
      }
      
      // 更新总价
      updateTotalPrice();
    });
    
    // 添加到购物车
    $('.variant-popup-form').on('submit', function(e) {
      e.preventDefault();
      
      const $form = $(this);
      const $submitButton = $form.find('.variant-popup-add-to-cart');
      
      // 禁用按钮，防止重复提交
      $submitButton.prop('disabled', true).text('Adding...');
      
      // 获取表单数据
      const formData = {
        items: [{
          id: $form.find('input[name="id"]').val(),
          quantity: parseInt($form.find('.quantity-selector__input').first().val())
        }]
      };
      
      // 发送添加到购物车请求
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: formData,
        dataType: 'json',
        success: function(data) {
          // 恢复按钮状态 - 使用正确的变量名
          $submitButton.prop('disabled', false).text('+ ADD TO CART');
          
          // 关闭弹窗
          closeVariantPopup();
          
          // 使用与product-info-2025完全相同的方法显示成功提示
          if (typeof $.showFormReminder === 'function') {
            $.showFormReminder({
              action: 'add-cart',
              status: 'success',
              message: 'Success'
            });
          } else {
            // 如果$.showFormReminder不可用，使用简单的成功提示
            alert('Added to cart');
          }
          
          // 刷新购物车计数
          $.getJSON('/cart.js', function(cart) {
            if ($('.cart-count-bubble').length) {
              $('.cart-count-bubble').text(cart.item_count);
            }
          });
        },
        error: function(error) {
          console.error('Error:', error);
          
          // 恢复按钮状态 - 使用正确的变量名
          $submitButton.prop('disabled', false).text('+ ADD TO CART');
          
          // 使用与product-info-2025完全相同的方法显示错误提示
          if (typeof $.showFormReminder === 'function') {
            $.showFormReminder({
              action: 'add-cart',
              status: 'error'
            });
          } else {
            alert('Failed to add to cart: ' + error.responseJSON.description);
          }
        }
      });
    });
    
    // 初始化时更新减号按钮状态
    $('.quantity-selector__button--minus').prop('disabled', parseInt($('.quantity-selector__input').first().val()) <= 1);
    
    // 初始化时更新总价
    updateTotalPrice();
    
    // 初始化AddToAny分享按钮
    initAddToAny();
  }

  // 更新选中的变体
  function updateSelectedVariant() {
    // 确保productData存在
    if (!window.productData || !window.productData.variants) {
      return;
    }
    
    // 获取当前选中的选项
    function getCurrentOptions() {
      const options = [];
      $('.variant-popup-option').each(function() {
        const $selectedOption = $(this).find('input:checked');
        if ($selectedOption.length) {
          options.push($selectedOption.val());
        }
      });
      return options;
    }
    
    // 获取当前选中的选项
    const selectedOptions = getCurrentOptions();
    
    // 获取产品变体数据
    const productVariants = window.productData.variants;
    
    // 查找匹配的变体
    const selectedVariant = productVariants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });
    
    if (selectedVariant) {
      // 更新隐藏的变体ID
      $('input[name="id"]').val(selectedVariant.id);
      
      // 更新添加到购物车按钮状态
      const $addToCartBtn = $('.variant-popup-add-to-cart');
      if (selectedVariant.available) {
        $addToCartBtn.prop('disabled', false).text('+ ADD TO CART');
      } else {
        $addToCartBtn.prop('disabled', true).text('SOLD OUT');
      }
      
      // 更新优惠百分比标签
      updateDiscountBadge(selectedVariant);
      
      // 更新价格 - 使用updateTotalPrice函数
      updateTotalPrice();
    }
  }

  // 更新优惠百分比标签
  function updateDiscountBadge(variant) {
    const $discountBadge = $('.variant-popup-discount-badge');
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discountPercentage = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      
      if ($discountBadge.length) {
        // 更新现有标签
        $discountBadge.find('span').text(`${discountPercentage}%OFF`);
      } else {
        // 创建新标签
        const $badge = $(`<div class="variant-popup-discount-badge"><span>${discountPercentage}%OFF</span></div>`);
        $('.variant-popup-product-media').append($badge);
      }
    } else {
      // 如果没有折扣，移除标签
      $discountBadge.remove();
    }
  }

  // 更新总价格
  function updateTotalPrice() {
    // 确保productData存在
    if (!window.productData || !window.productData.variants) {
      // 尝试从脚本标签重新加载产品数据
      try {
        const productDataFromScript = JSON.parse($('#product-data-script').text());
        window.productData = productDataFromScript;
      } catch (e) {
        return;
      }
      
      // 再次检查
      if (!window.productData || !window.productData.variants) {
        return;
      }
    }
    
    // 获取PC端和移动端的数量输入框
    const $pcQuantityInput = $('.popup-only-pc .quantity-selector__input');
    const $mobileQuantityInput = $('.popup-only-mobile .quantity-selector__input');
    
    // 获取PC端和移动端的数量值
    const pcQuantity = parseInt($pcQuantityInput.val() || 1);
    const mobileQuantity = parseInt($mobileQuantityInput.val() || 1);
    
    // 获取选中的变体ID
    let selectedVariantId = $('input[name="id"]').val();
    
    // 如果没有选中的变体ID，尝试获取第一个可用变体
    if (!selectedVariantId && window.productData && window.productData.variants) {
      const firstVariant = window.productData.variants[0];
      if (firstVariant) {
        selectedVariantId = firstVariant.id.toString();
      }
    }
    
    if (!selectedVariantId) {
      return;
    }
    
    // 查找选中的变体 - 尝试不同的方式匹配ID
    let selectedVariant = window.productData.variants.find(v => v.id.toString() === selectedVariantId);
    
    // 如果找不到，尝试使用数字比较
    if (!selectedVariant) {
      selectedVariant = window.productData.variants.find(v => Number(v.id) === Number(selectedVariantId));
    }
    
    // 如果仍然找不到，使用第一个变体
    if (!selectedVariant && window.productData.variants.length > 0) {
      selectedVariant = window.productData.variants[0];
      // 更新隐藏的变体ID
      $('input[name="id"]').val(selectedVariant.id);
    }
    
    if (!selectedVariant) {
      return;
    }
    
    // 获取单价
    const unitPrice = selectedVariant.price;
    
    // 计算PC端总价
    const pcTotalPrice = unitPrice * pcQuantity;
    
    // 构建PC端价格HTML
    let pcPriceHtml = `<span class="product-price__regular">${formatMoney(pcTotalPrice)}</span>`;
    
    if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
      const pcTotalComparePrice = selectedVariant.compare_at_price * pcQuantity;
      const pcTotalDiscount = pcTotalComparePrice - pcTotalPrice;
      
      pcPriceHtml += `<span class="product-price__compare">${formatMoney(pcTotalComparePrice)}</span>`;
      pcPriceHtml += `<span class="product-price__discount">-${formatMoney(pcTotalDiscount)}</span>`;
    }
    
    // 更新PC端价格显示
    $('.popup-only-pc .variant-popup-price').html(pcPriceHtml);
    
    // 计算移动端总价
    const mobileTotalPrice = unitPrice * mobileQuantity;
    
    // 构建移动端价格HTML
    let mobilePriceHtml = `<span class="product-price__regular">${formatMoney(mobileTotalPrice)}</span>`;
    
    if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
      const mobileTotalComparePrice = selectedVariant.compare_at_price * mobileQuantity;
      const mobileTotalDiscount = mobileTotalComparePrice - mobileTotalPrice;
      
      mobilePriceHtml += `<span class="product-price__compare">${formatMoney(mobileTotalComparePrice)}</span>`;
      mobilePriceHtml += `<span class="product-price__discount">-${formatMoney(mobileTotalDiscount)}</span>`;
    }
    
    // 更新移动端价格显示
    $('.popup-only-mobile .variant-popup-price').html(mobilePriceHtml);
  }
});
